const LINE_ITEM_FIELD_PREFIX = 'lineItem.';

export const AUTO_FILL_SCOPE = Object.freeze({
  TOP_LEVEL: 'topLevel',
  LINE_ITEM: 'lineItem',
});

export const isFieldVisible = (
  fieldName,
  refundModalType,
  customPaymentType,
) => {
  const fieldConfig = customPaymentType?.createRefundConfig;

  const field = fieldConfig?.find((config) => config.field === fieldName);
  return field?.isVisible?.[refundModalType] || false;
};

export const getFieldName = (fieldName, customPaymentType) => {
  const fieldConfig = customPaymentType?.createRefundConfig;
  const field = fieldConfig?.find((config) => config.field === fieldName);
  return field?.name || '';
};

export const getFieldLabel = (baseLabel, fieldName, customPaymentType) => {
  const configName = getFieldName(fieldName, customPaymentType);
  return configName ? `${baseLabel} (${configName})` : baseLabel;
};

export const getFieldAutoFill = (fieldName, customPaymentType) => {
  const fieldConfig = customPaymentType?.createRefundConfig;
  const field = fieldConfig?.find((config) => config.field === fieldName);
  return field?.autoFill;
};

const snakeToCamel = (str) =>
  str.replace(/_([a-z0-9])/g, (_, c) => c.toUpperCase());

export { snakeToCamel };

export const resolveAutoFillVariable = (key, ctx = {}) => {
  switch (key) {
    case 'client_facility_id':
      return ctx.selectedFacility?.client_facility_id ?? '';
    default:
      return '';
  }
};

export const getAutoFillDefaults = (customPaymentType, scope, ctx = {}) => {
  const defaults = {};
  const config = customPaymentType?.createRefundConfig || [];
  config.forEach((item) => {
    if (!item.field) return;
    let resolvedValue;
    if (item.autoFill?.type === 'default') {
      resolvedValue = item.autoFill.defaultValue ?? '';
    } else if (item.autoFill?.type === 'variable') {
      resolvedValue = resolveAutoFillVariable(item.autoFill.variable, ctx);
      if (resolvedValue === '') return;
    } else {
      return;
    }
    const isLineItem = item.field.startsWith(LINE_ITEM_FIELD_PREFIX);
    if (scope === AUTO_FILL_SCOPE.LINE_ITEM && isLineItem) {
      const key = item.field.slice(LINE_ITEM_FIELD_PREFIX.length);
      defaults[key] = resolvedValue;
    } else if (scope === AUTO_FILL_SCOPE.TOP_LEVEL && !isLineItem) {
      defaults[snakeToCamel(item.field)] = resolvedValue;
    }
  });
  return defaults;
};
